import React from 'react';
import Footer from './../Footer';
import { Link, withRouter } from 'react-router-dom';

import { Pages, Settings } from './Pages';

class Letter extends React.Component {

	constructor(props) {
		super(props);

		this.page = Pages[0];
		this.handleTogglePopout = this.handleTogglePopout.bind(this);
	}

	handleTogglePopout = popout => {
		this.props.togglePopout(popout);
	}

	componentDidMount() {
		this.props.bgHoverState(this.page.color);
		this.props.imageObjects(document.querySelectorAll(Settings.imageSelectors));

		document.title = `${this.page.name.replace('<br />', '')} | Peapack 100 Anniversary`;
		document.body.className = "page-inner page-letter";
	}

	render() {
		return  (
			<div className="page-wrapper">
				<div className="page">
					<div className="header-section wrapper">
						<div className="row">
							<div className="col-left col-md-6">
								<div className="header-content">
									<Link to="/" onClick={this.props.bgHoverState} className="back-button">Back</Link>
									<h1 dangerouslySetInnerHTML={{ __html: this.page.name }} />
									<div className="caption">Douglas L. Kennedy, President and Chief Executive Officer</div>
								</div>
							</div>
							<div className="col-right col-md-6">
								<figure className="header-thumbnail anim-up">
									<img src={`${process.env.PUBLIC_URL}/images/thumbnail-ceo-letter.jpg`} alt="" />
								</figure>
							</div>
						</div>
					</div> 
					<div className="white-background entry-content">
						<div className="wrapper">
							<div className="row">
								<div className="col-md-8">
                                    <p>When I started my banking career as a teller, a “bank” was a pillar of the community, a local brick-and-mortar building where customers made deposits and withdrawals or applied for loans in person.</p>
									<p>Today’s banks can hardly recognize that description. In the digital era, the bank’s community is defined by people, service, and solutions, rather than a geographical region. Internet and mobile banking offer businesses and individuals an endless range of options for their banking needs. Furthermore, the regulatory environment has made the banking industry more difficult to navigate. Throughout my banking career, over ten thousand banks have disappeared—most have merged into a handful of large national banks.</p>
									<p>In this environment, Peapack-Gladstone Bank has continued to provide a viable alternative that has not only enabled us to survive, but to thrive in a rapidly changing landscape.</p>
									<p>It turns out that our foundation—built on five core principles&mdash;has never gone out of style. For 100 years, Peapack-Gladstone Bank has put clients first. Our founders understood that, as has every president and CEO since. Times may change, but values built on integrity and trust do not.</p>
								</div>
								<div className="col-md-4">
									<div className="pullout-text">
										Peapack-Gladstone Bank <strong>Core Principles</strong>
									</div>
									<div className="core-principles">
										<p>Professionalism</p>
										<p>Clients First</p>
										<p>Compete to Win </p>
										<p>Invested in Our Community </p>
										<p>One Team</p>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-md-8">
									<p>As CEO, I have been charged with bringing Peapack-Gladstone Bank into its second century. Relying on the foundation built by those before me—Ellis Tiger, F.K. Stevens, G.F. Hill, T. Leonard Hill, George Jenkins, and Frank Kissel—will enable us to continue to adapt to changing times.</p>
									<p>I invite you to enjoy this glimpse into our history. Our foundation is strong, and our future success is built on the strength of our past. The world is changing, our clients’ needs and expectations are changing, but our core values of integrity and trust remain unwavering.</p>
									<figure className="sig no-anim mb-md-0 mb-8">
										<img src={`${process.env.PUBLIC_URL}/images/sig.png`} alt="" />
										<strong>Douglas L. Kennedy</strong>
										President &amp; Chief Executive Officer
									</figure>
								</div>
							</div>	
						</div>
					</div>
					<div className="hero-background pt-8 pb-1">
						<div className="wrapper">
							<h3 className="big mb-6">Peapack-Gladstone Financial Corporation Board of Directors (2021)</h3>
							<div className="row row35">
								<div className="col-lg-3 col-md-4 col-sm-6">
									<div className="thumbnail-wrap">
										<figure className="full">
											<img src={`${process.env.PUBLIC_URL}/images/meyercord.jpg`} alt="" />
										</figure>
										<strong>F. Duffield Meyercord &mdash; Chairman of the Board</strong>
										Managing Partner<br />
										Carl Marks Advisors
									</div>
								</div>
								<div className="col-lg-3 col-md-4 col-sm-6">
									<div className="thumbnail-wrap">
										<figure className="full">
											<img src={`${process.env.PUBLIC_URL}/images/kennedy.jpg`} alt="" />
										</figure>
										<strong>Douglas L. Kennedy</strong>
										President &amp; Chief Executive Officer<br />
										Peapack-Gladstone Bank
									</div>
								</div>
								<div className="col-lg-3 col-md-4 col-sm-6">
									<div className="thumbnail-wrap">
										<figure className="full">
											<img src={`${process.env.PUBLIC_URL}/images/bowser.jpg`} alt="" />
										</figure>
										<strong>Carmen M. Bowser</strong>
										Managing Vice President, Commercial Real Estate Division<br />
										Capital One Bank, N.A. <br />
										(Retired)
									</div>
								</div>
								<div className="col-lg-3 col-md-4 col-sm-6">
									<div className="thumbnail-wrap">
										<figure className="full">
											<img src={`${process.env.PUBLIC_URL}/images/cole.jpg`} alt="" />
										</figure>
										<strong>Dr. Susan A. Cole</strong>
										President<br />
										Montclair State University
									</div>
								</div>
								<div className="col-lg-3 col-md-4 col-sm-6">
									<div className="thumbnail-wrap">
										<figure className="full">
											<img src={`${process.env.PUBLIC_URL}/images/consi.jpg`} alt="" />
										</figure>
										<strong>Anthony J. Consi, II</strong>
									</div>
								</div>
								<div className="col-lg-3 col-md-4 col-sm-6">
									<div className="thumbnail-wrap">
										<figure className="full">
											<img src={`${process.env.PUBLIC_URL}/images/daingerfield.jpg`} alt="" />
										</figure>
										<strong>Richard Daingerfield</strong>
										Executive Vice President and General Counsel<br />
										Citizens Financial Group <br />
										(Retired)
									</div>
								</div>
								<div className="col-lg-3 col-md-4 col-sm-6">
									<div className="thumbnail-wrap">
										<figure className="full">
											<img src={`${process.env.PUBLIC_URL}/images/gramigna.jpg`} alt="" />
										</figure>
										<strong>Edward A. Gramigna, Jr.</strong>
										Partner and Member of the Management Board <br />
										Faegre Drinker Biddle &amp; <br />
										Reath, LLP 
									</div>
								</div>
								<div className="col-lg-3 col-md-4 col-sm-6">
									<div className="thumbnail-wrap">
										<figure className="full">
											<img src={`${process.env.PUBLIC_URL}/images/horst.jpg`} alt="" />
										</figure>
										<strong>Peter Horst</strong>
										Chief Executive Officer<br />
										PSB
									</div>
								</div>
								<div className="col-lg-3 col-md-4 col-sm-6">
									<div className="thumbnail-wrap">
										<figure className="full">
											<img src={`${process.env.PUBLIC_URL}/images/kass.jpg`} alt="" />
										</figure>
										<strong>Steven A. Kass</strong>
										Chief Executive Officer<br />
										Kass Advisory LLC<br />
										Chief Executive Officer<br />
										Rothstein Kass<br />
										(Retired)
									</div>
								</div>
								<div className="col-lg-3 col-md-4 col-sm-6">
									<div className="thumbnail-wrap">
										<figure className="full">
											<img src={`${process.env.PUBLIC_URL}/images/mullen.jpg`} alt="" />
										</figure>
										<strong>Patrick Mullen</strong>
										Director of Banking New Jersey Department of Banking and Insurance <br />
										(Retired)
									</div>
								</div>
								<div className="col-lg-3 col-md-4 col-sm-6">
									<div className="thumbnail-wrap">
										<figure className="full">
											<img src={`${process.env.PUBLIC_URL}/images/smith.jpg`} alt="" />
										</figure>
										<strong>Philip W. Smith, III</strong>
										President<br />
										Phillary Management, Inc.
									</div>
								</div>
								<div className="col-lg-3 col-md-4 col-sm-6">
									<div className="thumbnail-wrap">
										<figure className="full">
											<img src={`${process.env.PUBLIC_URL}/images/spinelli.jpg`} alt="" />
										</figure>
										<strong>Tony Spinelli</strong>
										Chief Information Officer<br />
										Urban One
									</div>
								</div>
								<div className="col-lg-3 col-md-4 col-sm-6">
									<div className="thumbnail-wrap">
										<figure className="full">
											<img src={`${process.env.PUBLIC_URL}/images/welsh.jpg`} alt="" />
										</figure>
										<strong>Beth Welsh</strong>
										Managing Partner<br />
										Bassett Associates
									</div>
								</div>
								<div className="col-lg-3 col-md-4 col-sm-6">
									<div className="thumbnail-wrap">
										<h3>Directors Emeritus:</h3>
										<p>Pamela Hill</p>
										<p>Frank A. Kissel<br />Chairman Emeritus</p>
										<p>John D. Kissel</p>
										<p>James R. Lamb, Esq.</p>
										<p>Edward A. Merton</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<Footer togglePopout={this.handleTogglePopout} />
				</div>
			</div>
		)
	}
}

export default withRouter(Letter);